import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePreference, resetPreferences, loadPreferences, savePreferences } from '../../modules/preferences/actions.js';
import { getPreferenceState } from '../../modules/preferences/selectors.js';

/**
 * A hook to retrieve and manage preferences
 * @returns {object} An object with the following properties:
 * @returns {object} `preferences` Current preference values
 * @returns {function} `updatePreference` A function to update a single preference value, takes 2 arguments for the name and value to set
 * @returns {function} `resetPreferences` A function to reset all preferences to default values
 * @returns {function} `loadPreferences` A function to load preferences from previously saved data (if configured)
 * @returns {function} `savePreferences` A function to save preferences for re-loading later (if configured)
 */

var usePreferences = function usePreferences() {
  var dispatch = useDispatch();
  var preferences = useSelector(getPreferenceState);
  var updatePreference$1 = useCallback(function (key, value) {
    dispatch(updatePreference(key, value));
  }, [dispatch, updatePreference]);
  var resetPreferences$1 = useCallback(function () {
    dispatch(resetPreferences());
  }, [dispatch, resetPreferences]);
  var loadPreferences$1 = useCallback(function (onLoadSuccess) {
    return dispatch(loadPreferences(onLoadSuccess));
  }, [dispatch, loadPreferences]);
  var savePreferences$1 = useCallback(function () {
    return dispatch(savePreferences());
  }, [dispatch, savePreferences]);
  return {
    preferences: preferences,
    updatePreference: updatePreference$1,
    resetPreferences: resetPreferences$1,
    loadPreferences: loadPreferences$1,
    savePreferences: savePreferences$1
  };
};

var usePreferences$1 = usePreferences;

export { usePreferences$1 as default };
